import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./FailedReportsEmailModalUpload.css";

class FailedReportsEmailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { failedReportsEmail, toggleFailedReportsEmailModal } = this.props;

    return (
      <SweetAlert
        customClass="FailedReportsEmailModalUpload__SweetAlert"
        title=""
        showConfirm={false}
        onConfirm={() => {}}
        // onCancel={() => toggleFailedReportsEmailModal()}
      >
        <div className="FailedReportsEmailModalUpload__Header">
          {failedReportsEmail.length > 0
            ? "Emails failed for the following reports"
            : "Documents Uploaded Successfully!"}
        </div>

        {failedReportsEmail.length > 0 && (
          <table className="FailedReportsEmailModalUpload__Table">
            <thead className="FailedReportsEmailModalUpload__Table__Thead">
              <tr>
                <th className="customTh FailedReportsEmailModalUpload__Table__Th">
                  #
                </th>
                <th className="customTh FailedReportsEmailModalUpload__Table__Th">
                  ID
                </th>
                <th className="customTh FailedReportsEmailModalUpload__Table__Th">
                  File
                </th>
              </tr>
            </thead>
            <tbody>
              {failedReportsEmail.map((item, i) => (
                <tr key={i}>
                  <td className="FailedReportsEmailModalUpload__Table__Td">
                    {" "}
                    {i + 1}
                    {" "}
                  </td>
                  <td className="FailedReportsEmailModalUpload__Table__Td">

                    {item.order_id}
                  </td>
                  <td className="FailedReportsEmailModalUpload__Table__Td">

                    {item.s3_url}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div>
          <button
            type="button"
            className="FailedReportsEmailModalUpload__CloseBtn"
            onClick={() => toggleFailedReportsEmailModal()}
          >
            Close
          </button>
        </div>

      </SweetAlert>
    );
  }
}

export default FailedReportsEmailModal;
